import React from 'react';
import { Box, Typography } from '@mui/material';
import ResponsiveNav from '../components/navigation/navigation';
import CartList from '../components/CartList/CartList';
import ManufacturerDp from '../assets/GiftAsset/ManufacturerDp.jpg';
import SelectedProduct from '../components/SelectedProduct/SelectedProduct';
import GiftSubHero from '../components/SubHero/SubHero';

const Cart = ({cartview}) => {
    const breadcrumbItems = [
        { label: 'Home', link: '/' },
        { label: 'Cart', link: '/product/cart' },
      ];
  return (
    <Box sx={{}}>
        <ResponsiveNav breadcrumbItems={breadcrumbItems} searchValue="" onSearchChange={() => {}} searchPlaceholder="Search..." />
        <Box>
            <Typography variant='h3' sx={{color:'rgba(86, 4, 246, 1)', my:2, fontSize:{xs:'1.5rem', md:'3rem'}}}>
                🛒Your Shopping Cart 
            </Typography>
            <Typography sx={{fontSize:'.8rem', my:2, color:'rgba(18, 18, 18, 0.8)'}}>
            Take a final look at your items before you complete your purchase.
            </Typography>
        </Box>
        <Box sx={{display:{xs:'block', md:'flex'}, justifyContent:'space-between', gap:6, height:{xs:'100%', md:'140vh'}, overflowY:'auto', my:8}}>
            <Box sx={{height:'100%', width:{xs:'100%', md:'60%'}, position:'relative', display:'flex', flexDirection:'column', justifyContent:'space-between', mb:{xs:4, md:0}}}>
                <Typography color='rgba(0, 0, 0, 1)' sx={{fontSize:'1.25rem'}}>
                Your Cart List
                </Typography>
                <Box sx={{backgroundColor:{xs:'inherit', md:'rgba(255, 255, 255, 1)'}, borderRadius:'24px', border:'1px solid rgba(238, 230, 254, 1)', p:2, height:'95%'}}>
                    {/* Manufacturer start*/}
                    <Box sx={{display:'flex', gap:1, alignItems:'center'}}>
                        <img src={ManufacturerDp} alt="manufacturer" width={30} height={30}/>
                        <Box>
                            <Typography variant='h6' sx={{color:'rgba(18, 18, 18, 1)'}}>
                                Lush & Green Stores
                            </Typography>
                            <Typography sx={{color:'rgba(129, 139, 156, 1)', fontSize:'.8rem'}}>
                                Deals in all varieties of flower
                            </Typography>
                        </Box>
                    </Box>
                    {/* Manufacturer ends */}
                    {/* Cart List starts */}
                    <CartList/>
                    {/* Cart list ends */}
                </Box>
                
            </Box>
            <Box sx={{borderRadius:'24px', border:'1px solid rgba(238, 230, 254, 1)', p:2, height:'100%', width:{xs:'100%', md:'40%'}}}>
                <Typography variant='h6' sx={{color:'rgba(86, 4, 246, 1)', mt:2}}>
                    Product Summary
                </Typography>
                <Typography color='rgba(18, 18, 18, 0.8)' sx={{fontSize:'.8rem'}}>
                    View all details about your selected product—price, features, availability, and more.
                </Typography>
                <SelectedProduct title={'Luxury Flower Bouquet'} price={'₦10,000'}/>
            </Box>
        </Box>
        <GiftSubHero/>
    </Box>
  )
}

export default Cart